<template>
  <div>
    <v-select
        v-model="inscricao.inscricaoInstrumentoMusical.instrumentoMusical"
        :items="filtroInstrumentosMusicais"
        :rules="[campoObrigatorioRule(inscricao.inscricaoInstrumentoMusical.instrumentoMusical.oid)]"
        dense
        item-text="oid"
        label="Instrumento Musical *"
        outlined
        return-object
        validate-on-blur
    >
      <template v-slot:selection="data">
        <v-chip-group>
          <v-sheet class="mx-1" color="grey lighten-2" rounded>
            <span class="mx-2 d-flex">{{ data.item.nome }}</span>
          </v-sheet>
        </v-chip-group>
      </template>
      <template v-slot:item="data">
        <v-chip-group>
          <v-sheet class="mx-1" color="grey lighten-2" rounded>
            <span class="mx-2 d-flex">{{ data.item.nome }}</span>
          </v-sheet>
        </v-chip-group>
      </template>
    </v-select>
    <v-text-field
        v-if="possuiInstrumentoMusicalOutro"
        v-model="inscricao.inscricaoInstrumentoMusical.nomeInstrumentoMusical"
        :rules="[campoObrigatorioRule]"
        dense
        label="Nome do instrumento *"
        name="inscricaoNomeInstrumento"
        maxlength="60"
        outlined
    ></v-text-field>
    <v-select
        v-if="opcaoComDoisInstrumentos"
        v-model="inscricao.inscricaoInstrumentoMusical.instrumentoMusical2"
        :items="filtroInstrumentosMusicais2"
        :rules="inscricao.opcao.nomeOpcao.includes('Regência') ? [campoObrigatorioRule(inscricao.inscricaoInstrumentoMusical.instrumentoMusical.oid)] : []"
        dense
        item-text="oid"
        :label="inscricao.opcao.nomeOpcao.includes('Regência') ? 'Segundo Instrumento Musical *' : 'Segundo Instrumento Musical (Opcional)'"
        outlined
        clearable
        return-object
        validate-on-blur
    >
      <template v-slot:selection="data">
        <v-chip-group>
          <v-sheet class="mx-1" color="grey lighten-2" rounded>
            <span class="mx-2 d-flex">{{ data.item.nome }}</span>
          </v-sheet>
        </v-chip-group>
      </template>
      <template v-slot:item="data">
        <v-chip-group>
          <v-sheet class="mx-1" color="grey lighten-2" rounded>
            <span class="mx-2 d-flex">{{ data.item.nome }}</span>
          </v-sheet>
        </v-chip-group>
      </template>
    </v-select>
    <v-text-field
        v-if="possuiInstrumentoMusicalOutro2 && opcaoComDoisInstrumentos"
        v-model="inscricao.inscricaoInstrumentoMusical.nomeInstrumentoMusical2"
        :rules="possuiInstrumentoMusicalOutro2 ? [campoObrigatorioRule] : []"
        dense
        label="Nome do instrumento *"
        name="inscricaoNomeInstrumento"
        maxlength="60"
        outlined
    ></v-text-field>
  </div>
</template>

<script>
import rules from "@/commons/rules";
import instrumentoMusicalService from "@/services/instrumentoMusical.service";

export default {
  name: "EscolhaInstrumentoMusicalSelect",

  props: {
    inscricao: {type: Object, required: true}
  },

  data() {
    return {
      instrumentosMusicais: []
    }
  },

  async created() {
    await instrumentoMusicalService
        .recuperarInstrumentoMusical()
        .then(response => {
          this.instrumentosMusicais = response.data;
        })
        .catch(() => {
        })
  },

  computed: {
    possuiInstrumentoMusicalOutro() {
      return (
          !!this.inscricao.inscricaoInstrumentoMusical &&
          !!this.inscricao.inscricaoInstrumentoMusical.instrumentoMusical &&
          this.inscricao.inscricaoInstrumentoMusical.instrumentoMusical.nome === "Outro"
      );
    },

    possuiInstrumentoMusicalOutro2() {
      return (
          this.opcaoComDoisInstrumentos &&
          !!this.inscricao.inscricaoInstrumentoMusical &&
          !!this.inscricao.inscricaoInstrumentoMusical.instrumentoMusical2 &&
          this.inscricao.inscricaoInstrumentoMusical.instrumentoMusical2.nome === "Outro"
      );
    },

    filtroInstrumentosMusicais() {
      if (this.inscricao.opcao.nomeOpcao.includes("Regência")) {
        return this.instrumentosMusicais.filter(i => i.nome === "Piano")
      }

      return this.instrumentosMusicais;
    },

    filtroInstrumentosMusicais2() {
      if (this.inscricao.opcao.nomeOpcao.includes("Regência")) {
        return this.instrumentosMusicais.filter(i => i.nome !== "Outro")
      }

      return this.instrumentosMusicais;
    },

    opcaoComDoisInstrumentos() {
      return this.inscricao.opcao.nomeOpcao.includes('Composição') ||
             this.inscricao.opcao.nomeOpcao.includes("Regência");
    }
  },

  methods: {
    ...rules,
  }
};
</script>
